import * as types from "./types";
import { getMessages, getChats, getCases, saveCases } from "src/auth/auth";

const initialState = {
  list: undefined,
  messages: getMessages(),
  chats: getChats(),
  casesUpdateRequired: true
} as types.CaseState;

export default function reducer(
  state = initialState,
  action: types.CaseAction
): types.CaseState {
  switch (action.type) {
    case types.LOAD_CACHED_CASES:
      //saveCases(action.cases);
      return {
        ...state,
        list: action.cases,
        casesUpdateRequired: true,
        cacheLoaded: true
      };
    case types.FETCH_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.notifications
      };
    case types.FETCH_CASES:
      //saveCases(action.cases);
      return {
        ...state,
        list: action.cases,
        casesUpdateRequired: false
      };
    case types.SET_CASE_UPDATE_REQUIRED:
      return {
        ...state,
        casesUpdateRequired: true
      };
    case types.FETCH_USERS:
      return {
        ...state,
        users: action.users
      };
    case types.FETCH_ROLES:
      return {
        ...state,
        roles: action.roles
      };
    case types.FETCH_MAIL_LIST:
      return {
        ...state,
        mailList: action.mailList
      };
    case types.FETCH_CATEGORIES:
      return {
        ...state,
        categories: action.categories
      };
    case types.FETCH_CHATS:
      return {
        ...state,
        chats: action.chats
      };
    case types.FETCH_MESSAGES:
      return {
        ...state,
        messages: action.messages
      };
    case types.FETCH_REPORTS:
      return {
        ...state,
        reports: action.reports
      };
    case types.FETCH_TAGS:
      return {
        ...state,
        tags: action.tags
      };
    case types.FETCH_MESSAGE_TEMPLATES:
      return {
        ...state,
        messageTemplates: action.messageTemplates
      };
    case types.BIND_MESSAGES:
      const messages = state.messages.map(m => {
        if (action.messageIds.findIndex(s => s === m.id) > -1) {
          m.report_id = action.reportId;
          m.case_id = action.caseId;
        }
        return m;
      });
      return {
        ...state,
        messages: messages
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/cases/reducer.ts